import { Component } from '@angular/core';
import { UscMobileActionPlansComponent } from '../usc-mobile-action-plans/usc-mobile-action-plans.component';

@Component({
    selector: 'sn-usc-this-month-action-plans',
    templateUrl: '../usc-table-view/usc-table-view.component.html',
    styleUrls: ['../usc-mobile-action-plans/usc-mobile-action-plans.component.css', '../usc-table-view/usc-table-view.component.css']
})

export class UscThisMonthActionPlansComponent extends UscMobileActionPlansComponent {

    ngOnInit() {
        this.view = this.uscStoreService.view_p2w_team_this_action_plans;
        this.is_current_month = true;
        super.ngOnInit();
    }

    getDataView() { return this.uscStoreService.view_p2w_team_action_plan; }

}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-this-month-action-plans/usc-this-month-action-plans.component.ts